<grid-with-search
  [gridData]="vendorsList"
  [gridColumns]="gridColumns"
  (deleteGridItem)="deleteVendor($event)"
  (addNewGridItem)="addVendor($event)"
  (editGridItem)="updateVendor($event)"
  (updateStatusChange)="updateStatusChange($event)"
  [enableSwitchTooltip]="enableSwitchTooltip"
  [SearchPlaceHolder]="SearchPlaceHolder"
  [editableMaxLength]="45"
  [NoDataText]="NoDataText"
  [deleteLabel]="deleteLabel"
  [deleteConfirmationMessage]="deleteConfirmationMessage"
  (bulkDeleteGridItems)="bulkDeleteVendors($event)"
></grid-with-search>